import type { LibraryResponses } from "@tfg/types/endpoints/library"

import type { FindContactResponseDto } from "~/gen/api/types"

/**
 * Calculate remaining information requests from the count object
 */
export function calculateRemainingInformationRequests(
  informationRequestsCount: Record<string, number>
): number {
  const total = Object.values(informationRequestsCount).reduce(
    (a, b) => a + b,
    0
  )
  const completed = informationRequestsCount.CLOSED || 0
  return total - completed
}

/**
 * Calculate remaining certificate requests from the count object
 */
export function calculateRemainingCertificateRequests(
  certificateRequestsCount: Record<string, number>
): number {
  const total = Object.values(certificateRequestsCount).reduce(
    (a, b) => a + b,
    0
  )
  const completed =
    (certificateRequestsCount.SUBMITTED || 0) +
    (certificateRequestsCount.REJECTED || 0) +
    (certificateRequestsCount.ACCEPTED || 0)
  return total - completed
}

/**
 * Convert FindContactResponseDto to a format compatible with TransferContactModal
 * The modal expects LibraryResponses.SupplierDetails but we only need id, email, and language
 */
export function convertContactForTransferModal(
  contact: FindContactResponseDto["supplier"]
): Pick<LibraryResponses.SupplierDetails, "id" | "email" | "language"> {
  return {
    id: contact.id,
    email: contact.email,
    language: contact.preferedLangageIso6391,
  }
}
